import { useHistory } from 'react-router';
import { Typography } from 'seagull';
import { routes } from "../../../constants";
import { useIoContext, useOverlayContext, useStore, useStoreActions } from "../../../contexts";
import { handleRequest } from "../../../infra/utils";
import { integrationModel } from "../../../models";
import { EmailOnBehalfTypes } from "../../../models/EmailOnBehalfSettingsModel";
import { getEmailProviderDetails, Tab } from "../../../pages/NotificationSettings/NotificationSettings.utils";
import { selectors } from "../../../store/state-selectors";
import outlookLogo from "../../../../assets/Outlook.png";
import IntegrationCard from "../IntegrationCard/IntegrationCard";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function OutlookCard(_ref) {
  let {
    integration,
    isDisabled
  } = _ref;
  const businessId = useStore(selectors.user.businessId);
  const {
    api
  } = useStoreActions();
  const changeLocation = useIoContext().changeLocation;
  const {
    startLoader,
    stopLoader,
    showErrorToast
  } = useOverlayContext();
  const {
    logBI
  } = useStoreActions();
  const history = useHistory();
  const connect = async () => {
    const providerDetails = getEmailProviderDetails(EmailOnBehalfTypes.Outlook);
    if (integrationModel.isLinked(integration)) {
      history.push(routes.notifications, {
        selectedTab: Tab.Client
      });
      return;
    }
    logBI(providerDetails.biCodes.connect, {
      vendorId: businessId
    });
    if (businessId) {
      startLoader();
      const result = await handleRequest(api.notification.emailOnBehalf.connectEmailOnBehalf({
        businessId,
        provider: EmailOnBehalfTypes.Outlook,
        pageUrl: window.location.origin + window.location.pathname
      }));
      if (result.success) {
        changeLocation(result.data);
      } else {
        logBI(providerDetails.biCodes.authError, {
          vendorId: businessId
        });
        showErrorToast("Failed to connect outlook account - please try again", "start-outlook-flow-error-toast");
      }
      stopLoader();
    } else {
      logBI(providerDetails.biCodes.authError, {
        vendorId: businessId
      });
      showErrorToast('please refresh and try again', 'no-business-id-error-toast');
    }
  };
  return /*#__PURE__*/_jsx(IntegrationCard, {
    "data-testid": "outlook-card",
    icon: /*#__PURE__*/_jsx(IntegrationCard.LogoImg, {
      src: outlookLogo
    }),
    title: "Outlook",
    subTitle: "Send client communications through your Outlook mailbox.",
    mainAction: /*#__PURE__*/_jsx(IntegrationCard.MainActionButton, {
      onClick: connect,
      "data-testid": "outlook-card-connect",
      disabled: isDisabled,
      tooltip: isDisabled ? {
        placement: 'right',
        title: /*#__PURE__*/_jsxs("div", {
          "data-testid": "outlook-card-tooltip",
          children: [/*#__PURE__*/_jsx(Typography, {
            variant: "paragraph1",
            skin: "invertedStandard",
            children: "Only one mailbox can be connected at a time."
          }), /*#__PURE__*/_jsx(Typography, {
            variant: "paragraph1",
            skin: "invertedStandard",
            children: "Disconnect Gmail first to connect your Outlook mailbox."
          })]
        })
      } : undefined,
      children: integrationModel.isLinked(integration) ? 'Manage connection' : 'Connect'
    })
  });
}